﻿"use strict";

/* @preserve
// ------------------------------------------
// Forgot Password JS
// ------------------------------------------
*/

// Global Variables
// ------------------------------------------
if (document.body.classList.contains("local")) {
    window.localSide = true;
    window.developmentSide = true;
}

(async () => { 
	// Cached Variables
	const form = document.getElementById("frmForgotPassword");

    // Get the version number.
    // ------------------------------------------
    const versionNumber = document.body.getAttribute("data-version");
    window.version = versionNumber;

	// Remove the "no-js" class from the HTML document.
	// ------------------------------------------
	document.documentElement.classList.remove("no-js");

	// Google Analytics
    // ------------------------------------------
    await FLPPR_loader("https://www.googletagmanager.com/gtag/js?id=G-LVVLE17TCD",null,false,"js");
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-LVVLE17TCD');
	
	// Ladda
	// Stop Ladda when leaving the page - used to make sure it's not still running when users hit the back button.
	// ------------------------------------------
    await FLPPR_loader(`/node_modules/ladda/dist/spin.min.js?version=${window.version}`);
    await FLPPR_loader(`/node_modules/ladda/dist/ladda.min.js?version=${window.version}`);
	Ladda.bind("button.btn.ladda-button");
	window.addEventListener("pagehide", e => { if (typeof Ladda === "object") { Ladda.stopAll(); } });

	// Initial focus
	// ------------------------------------------
	if (form !== null) {
		document.getElementById("EmailAddress").focus();
	}
	
	// Reenable the submit button.
	// ------------------------------------------
	if (form !== null) {
		form.querySelector('button[type="submit"]').disabled = false;
	}

	// Validation
	// ------------------------------------------
	if (form !== null) {
		$(form).validate({
			errorClass: "invalid",
			event: "submit",
			rules: {
				EmailAddress: {
					required: true,
					email: true
				}
			},
			messages: {
				EmailAddress: {
					required: "Please enter an email address.",
					email: "Please enter a valid email address."
				}     
			},
			invalidHandler: (form, validator) => {
				if (validator.numberOfInvalids()) {
					if (console.groupCollapsed !== undefined) {
						console.groupCollapsed("[Validation] Errors: [", Object.keys(validator.errorMap).length, "]");
					} else {
						console.warn("[Validation] Errors: [", Object.keys(validator.errorMap).length, "]");
					}
					let errorCount = 1;
					for (let i in validator.errorMap) { 
						console.warn("#" + errorCount + " - ", i, ":", validator.errorMap[i], "Element: ", validator.errorList[0].element); 
						++errorCount; 
					}
					if (console.groupCollapsed !== undefined) { console.groupEnd(); }
					Ladda.stopAll();
				}
			}
		});
	}

	// Load the modal plugin and all associated files.
	// This is so we can display the privacy policy/terms of use buttons.
	// ------------------------------------------
	if (window.localSide === true) {
		await FLPPR_loader("/SharedResources/js/src/FLPPR/js/FLPPR-utilities.js");
		await FLPPR_loader("/SharedResources/js/src/FLPPR/js/FLPPR-loadingspinner.js");
		await FLPPR_loader("/SharedResources/js/src/FLPPR/js/FLPPR-modal.js");
	} else {
        await FLPPR_loader(`/SharedResources/js/dist/FLPPR/js/FLPPR-utilities.min.js?version=1.0?version=${window.version}`);
        await FLPPR_loader(`/SharedResources/js/dist/FLPPR/js/FLPPR-loadingspinner.min.js?version=${window.version}`);
        await FLPPR_loader(`/SharedResources/js/dist/FLPPR/js/FLPPR-modal.min.js?version=${window.version}`);
	}
	// Loading Spinner
    FLPPR_loadingspinner.init({ 
        debug: window.localSide 
    });
	// Modals
	await FLPPR_modal.init({
		debug: false,
		bootstrapVersion: 4,
		alignment: "center",
		pathPrefix: ""
	});

	// Open the "Privacy Policy" modal.
	// ------------------------------------------
	$(document).on("click",".btn-privacypolicy",e => {
		FLPPR_modal.load({
			title: "Privacy Policy",
			source: "login/modals/modal-privacypolicy",
			script: false
		});
		e.preventDefault();
	});

	// Open the "Terms of Use" modal.
	// ------------------------------------------
	$(document).on("click",".btn-termsofuse",e => {
		FLPPR_modal.load({
			title: "Terms of Use",
			source: "login/modals/modal-termsofuse",
			script: false
		});
		e.preventDefault();
	});

	// Open the "About" modal.
	// ------------------------------------------
	$(document).on("click",".btn-about",e => {
		FLPPR_modal.load({
			title: "About",
			source: "about/about"
		});
		e.preventDefault();
	});

	// Un-disable the buttons.
	// ------------------------------------------
	document.querySelector(".btn-privacypolicy").removeAttribute("disabled");
	document.querySelector(".btn-termsofuse").removeAttribute("disabled");
	document.querySelector(".btn-about").removeAttribute("disabled");
})();